import { memo } from 'react';
import { Formik, FormikConfig, FormikHelpers, useFormikContext } from 'formik';

import dayjs from 'lib/dayjs';

export interface FilterFormValues extends Omit<Remind.DetailFilter, 'pageNo' | 'pageSize'> {}

type FV = FilterFormValues;

export type FilterFormHelpers = FormikHelpers<FV>;

export interface FilterFormProps extends Omit<FormikConfig<FV>, 'initialValues'> {
  initialValues?: FV;
}

export const defaultInitialValues: FV = {
  platformRegion: [
    {
      platform: 'SHOPEE',
      region: [],
    },
    {
      platform: 'LAZADA',
      region: [],
    },
  ],
  scene: [],
  startTime: dayjs().subtract(6, 'day').startOf('day').valueOf(),
  endTime: dayjs().endOf('day').valueOf(),
  timeZone: -Math.floor(new Date().getTimezoneOffset() / 60),
  storeId: [],
  assistantId: [],
};

function FilterForm(props: FilterFormProps) {
  const { initialValues = defaultInitialValues, ...otherProps } = props;

  return <Formik enableReinitialize initialValues={initialValues} {...otherProps} />;
}

export const useFilterForm = () => {
  return useFormikContext<FV>();
};

export default memo(FilterForm);
